import React from 'react';
import './AddProductMulti.scss';
import TitleWithLine from "../TitleWithLine/TitleWithline";
import LabelInput from "../LabelInput/LabelInput";
import LabelSelectBox from "../LabelSelectBox/LabelSelectBox";

const AddProductMulti = ({sendData, ProducData, setSendData}) => {

  const inputHandler = (event) => {
    setSendData({
      ...sendData, kala: {
        ...sendData?.kala,
        NameKala: event.target.value
      }
    })
  }

  const AnbarHandler = (e, v) => {
    setSendData({
      ...sendData, kala: {
        ...sendData?.kala,
        Anbar: v.label,
        AnbarId: v.value
      }
    })
  }

  const GroupHandler = (e, v) => {
    setSendData({
      ...sendData, kala: {
        ...sendData?.kala,
        GroupKala: v.label,
        GroupKalaId: v.value
      }
    })
  }

  return (
    <div className="main-product">

      <TitleWithLine title="تعریف کالا" LineClass="line-solid"/>

      <LabelInput
        labelText="نام کالا"
        onChange={inputHandler}
        id={"NProduct"}
        value={sendData?.kala?.NameKala}
        type={"text"}
        placeholder={"متن موردنظر خود را وارد کنید"}
        className={""}/>


      <div className={"parent-add-site"}>
        <label>افزودن به سایت</label>
        <div className="radio">
          <input
            checked={sendData?.sendToSite}
            name="gender"
            id="male"
            type="radio"
            label="فعال"
            onClick={() => setSendData({...sendData, sendToSite: 1})}
          />
          <input
            checked={!sendData?.sendToSite}
            name="gender"
            id="other"
            type="radio"
            label="غیر فعال"
            onClick={() => setSendData({...sendData, sendToSite: 0})}
          />
        </div>
      </div>

      <LabelSelectBox
        className="W-49"
        labelText={"نوع انبارگردانی"}
        defaultValue={sendData?.kala?.AnbarId}
        options={ProducData?.kala?.anbar}
        onSelect={AnbarHandler}
      />

      <LabelSelectBox
        className="W-49"
        labelText={"گروه کالا"}
        defaultValue={sendData?.kala?.GroupKalaId}
        options={ProducData?.kala?.grkala}
        onSelect={GroupHandler}
      />

    </div>
  );
}

export default AddProductMulti;